module.exports = __webpack_public_path__ + "assets/icon-theme-deselected.a31e9d18.svg";